import React                      from 'react';
import { connect }                from 'react-redux';
import { NavLink }                from 'react-router-dom';
import { reset, SubmissionError } from 'redux-form';
import { useTranslation }         from 'react-i18next';

import Meta                from '../../../components/meta';
import PageHeader          from '../../../components/pageHeader';
import Preloader           from '../../../components/containers/preloader';
import { useVerification } from '../../../providers/verification';
import { useCommon }       from '../../../providers/common';

import VerificationForm from './VerificationForm';

import qrXPng from '../../../assets/images/bg/qr-x.png';

const Verification = (props) => {
  const {
          dispatch,
        } = props;

  const { pages } = useCommon();

  const { t } = useTranslation();
  const {
          order,
          loading,
          initialStateLoaded,
          orderVerification,
        }     = useVerification();

  React.useEffect(() => {
    if (!isSSR()) {
      scrollTo({
        top:  0,
        left: 0,
      });
    }
  }, []);

  const submitForm = (event, handleSubmit) => {
    event.preventDefault();

    handleSubmit((values) => {
      return orderVerification(values.code)
        .then(() => dispatch(reset('VerificationForm')))
        .catch(errors => {
          throw new SubmissionError(errors);
        });
    })(event);
  };

  const page = pages.find(page => page.template === 'verification');
  const {
          label,
          ...otherOrder
        }    = order;

  return (
    <>
      <Meta {...page.meta} />
      <div className={'page-content'}>
        <PageHeader>{t('client_verification')}</PageHeader>
        <main id={'verification'}>
          <article>
            <section>
              <p>{t('client_verification_aboutCompany')}:</p>
            </section>
            <section>
              <NavLink to={'/kontakty'}>
                <span className={'ic-map'} />
                {t('schema_company_address')}
              </NavLink>
            </section>
            {!initialStateLoaded && (
              <section>
                <VerificationForm submitForm={submitForm} />
              </section>
            )}
          </article>
          <section className={'container'}>
            <div className={'content'}>
              {Object.keys(order).length > 0 && (
                <section>
                  <h3>{t('client_result')}:</h3>
                  <div className={'list'}>
                    <span><strong>{label}</strong></span>
                    {Object.values(otherOrder)
                      .map((item, itemKey) => (
                        <span key={itemKey}>{item.label}: <strong>{item.value}</strong></span>
                      ))}
                  </div>
                </section>
              )}
              <section>
                <h3>{t('client_verification_descriptionSteps_title')}:</h3>
                <ol>
                  <li>{t('client_verification_step1')}</li>
                  <li>{t('client_verification_step2')}</li>
                  <li>{t('client_verification_step3')}</li>
                </ol>
              </section>
            </div>
            <div className={'image'}>
              <picture>
                <img
                  src={qrXPng}
                  alt={t('client_verification')}
                />
              </picture>
            </div>
          </section>
        </main>
      </div>
      {loading && (
        <Preloader />
      )}
    </>
  );
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Verification);